import { render, staticRenderFns } from "./BusinessBuildingPage.vue?vue&type=template&id=4733e5fa&scoped=true&"
import script from "./BusinessBuildingPage.vue?vue&type=script&lang=js&"
export * from "./BusinessBuildingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4733e5fa",
  null
  
)

export default component.exports